import { Box, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import companyData from '../../../assets/data/company.json';
import IconComponent from '../../../components/icons/IconComponent';
import PhoneIcon from '../../../assets/icons/whatsapp.svg';
import AddressIcon from '../../../assets/icons/location.svg';
import GmailIcon from '../../../assets/icons/gmail.svg';
import { Link } from "react-router-dom";

const ContactInfo = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 4,
                    p: {xs: 3, md: 5},
                    flex: 1
                }}
            >
                <Stack
                    direction='column'
                    alignItems='start'
                    justifyContent='space-between'
                    spacing={{xs: 2, md: 3}}
                    height='100%'
                >
                     <Stack
                        direction='column'
                        alignItems='start'
                        justifyContent='start'
                        width='100%'
                        spacing={{xs: 2, md: 3}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 16, lg: 24}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={theme.palette.text.primary}
                        >
                            {t('contact.info.title')}
                        </Typography>

                        <Divider style={{width: '100%'}}/>
                    </Stack>

                    <Grid
                        direction='row'
                        justifyContent='start'
                        alignItems='start'
                        container
                        width='100%'
                        spacing={2}
                    >
                        <Grid size={{xs: 12, md: 4}}>
                            <ContactDetails 
                                title={t('contact.info.phone')}
                                description={companyData.contact.phone}
                                icon={PhoneIcon}
                                link={companyData.contact.whatsapp_link}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 8}}>
                            <ContactDetails 
                                title={t('contact.info.address')}
                                description={`${t('footer.location.sri_lanka.add_line_1')} ${t('footer.location.sri_lanka.add_line_2')} ${t('footer.location.sri_lanka.add_line_3')} ${t('footer.location.sri_lanka.city')}, ${t('footer.location.sri_lanka.country')}`}
                                icon={AddressIcon}
                            />
                        </Grid>

                        <Grid size={12}>
                            <ContactDetails 
                                title={t('contact.info.email')}
                                description={companyData.contact.email}
                                icon={GmailIcon}
                                link={`mailto:${companyData.contact.email}`}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default ContactInfo;

const ContactDetails = ({
    title,
    description,
    icon,
    link
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='row'
                justifyContent='start'
                alignItems='start'
                spacing={1}
            >
                <IconComponent 
                    icon={icon}
                    alt={title}
                />

                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='start'
                    spacing={1}
                >
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 14, lg: 16}}
                        textAlign="left"
                        lineHeight={1.5}
                        color={theme.palette.text.primary}
                    >
                        {title}
                    </Typography>

                    {
                        link
                        ?
                        <Link
                            to={link}
                            target="_blank"
                            style={{
                                textDecoration: 'none'
                            }}
                        >
                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 14, lg: 14}}
                                textAlign="left"
                                lineHeight={1.5}
                                color={theme.palette.text.secondary}
                                sx={{
                                    '&: hover': {
                                        color: theme.palette.primary.main,
                                        transform: 'scale(1.1)',
                                        fontWeight: 500
                                    }
                                }}
                            >
                                {description}
                            </Typography>
                        </Link>
                        :
                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 14, lg: 14}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {description}
                        </Typography>
                    }
                </Stack>
            </Stack>
        </>
    );
}